<template>
  <div>
    <img :src="require('@/assets/bg.png')" class="main">
   <div class="container-fluid row pt-3">
    <nav class="container mx-auto navbar navbar-expand-lg navbar-dark nav-dark pt-5">
        <a href="/" class="navbar-brand">
          <img src="@/assets/logo.png"> 
         <!-- <h6 class="text-light">TESTNET</h6> -->
      
        </a>
    </nav>
  </div>

  <div id="loading" v-if="show.showLoading">
    <div class="content">

      <v-icon name="spinner" pulse scale="3" />

    </div>
  </div>

    <div class="container col-10 containerBG">
      <div class="container">
        <b-button class="p-2  py-1 m-3 text-uppercase">
          BLX2 ASSETS
        </b-button>
      </div>
      <div class="container col-10 containerBG">
          <div class="card-container">
            <token-card
                align="center"
                v-for="name in tokens" :key="name.id" :name="name"
              />
          </div>
      </div>
    </div>
    
   
</div>


    
</template>
<script>
import TokenCard from './TokenCard.vue';

export default {
name: "TokenList",
components: {
   TokenCard
},
  data() {
    return {
      tokens: [],
      token: [],
      perPage: 10,
      currentPage: 1,
      symbol:"",
      name: '',
      
    }
  },
  computed: {
    init() {
            return this.$store.state.init;
        },

        errors() {
            return this.$store.state.errors;
        },

        show() {
            return this.$store.state.show;
        },

        action() {
            return this.$store.state.action;
        },

        list() {
            return this.$store.state.list;
        },

        rows() {
          return this.tokens.length
        },
       
    },
  methods:{
       getTokensList(){
         this.show.showLoading = true;
          this.axios.get('/pub/contract/symbols/', {
            headers: { 'content-type': 'application/x-www-form-urlencoded'}
             }).then((response) => {
              this.tokens = response.data;
              this.show.showLoading = false;

              let token = [];
              this.tokens.forEach((value, index) => {
                token.push(value);
                this.name = value
                
               
              })
          })
      },
      
    //   selectSymbol(symbol){
    //       localStorage.setItem("symbol", symbol)
    //       this.$router.push({
    //           name: 'Address', params: {
    //               symbol: symbol,
    //               walletAddress: localStorage.getItem("address")
    //           }
    //       })
          
    //       console.log('test')
    //   }
  },
  mounted: function(){
      this.getTokensList();
      
      
  }
    
    
}
</script>
<style scoped>
.card-container{
  display:flex;
  flex-wrap: wrap;
  align-content: center;
    justify-content: center;
}
.main{
    background-image: url('../assets/bg.png');
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
    background-position: center;
    background-size: cover;

}
.navbar-brand img{
  width: 10rem;
  margin: auto 100px;
}
.btn-block{
    width: 10rem !important;
    display: block;
    justify-content: center !important;
    margin: auto 100px;

}
.containerBG {
    display: flex;
    padding: 20px 0px;
    align-items: center;
    margin: 0 auto;
    flex-wrap: wrap;
    width: 100%;
  }
.productList {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
  }
</style>